const state = {
  lang: 'zh-CN',
  // isEnLang: false,
  isMobile: false,
  globalLayers: []
}

export default state
